import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  container: {
    width: '100vw',
    height: ['calc(80vh + 80px)',
    // mobile
    'calc(90vh + 90px)',
    // mobilelg
    'calc(100vh + 100px)',
    // tablet
    'calc(100vh + 100px)',
    // tabletlg
    'calc(100vh + 100px)',
    // desktop
    'calc(100vh + 100px)' // widescreen+
    ],
    minHeight: ['550px',
    // mobile
    '570px',
    // mobilelg
    '600px',
    // tablet
    '640px',
    // tabletlg
    '680px',
    // desktop
    '720px' // widescreen
    ],
    maxWidth: '100%',
    margin: '0 auto',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start'
  },
  wrapper: {
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    margin: '0 auto',
    position: 'relative'
  },
  parallaxText: (scrollY: number, maxScrollValues = [180, 180, 280, 350, 400, 450]) => {
    const clamp = (val: number, max: number) => Math.min(val, max);
    return {
      transform: [`translateY(${clamp(scrollY, maxScrollValues[0]) * 0.08}px)`,
      // mobile
      `translateY(${clamp(scrollY, maxScrollValues[1]) * 0.08}px)`,
      // mobilelg
      `translateY(calc(-50% + ${clamp(scrollY, maxScrollValues[2]) * 0.2}px))`,
      // tablet
      `translateY(calc(-50% + ${clamp(scrollY, maxScrollValues[3]) * 0.2}px))`,
      // tabletlg
      `translateY(calc(-50% + ${clamp(scrollY, maxScrollValues[4]) * 0.2}px))`,
      // desktop
      `translateY(calc(-50% + ${clamp(scrollY, maxScrollValues[5]) * 0.4}px))` // widescreen
      ],
      willChange: 'transform'
    };
  },
  parallaxCart: (scrollY: number) => ({
    transform: `translateY(${scrollY * 0.15}px)`,
    willChange: 'transform'
  }),
  textContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: ['auto', 'auto', 'max(320px, min(calc(50% - 40px), calc(100% - 240px)))', 'max(320px, min(calc(50% - 40px), calc(100% - 260px)))', 'max(340px, min(calc(50% - 40px), calc(100% - 280px)))', 'max(360px, min(calc(50% - 40px), calc(100% - 300px)))'],
    bottom: ['110px', '120px', 'auto', 'auto', 'auto', 'auto'],
    maxHeight: ['none', 'none', 'calc(100% - 240px)', 'calc(100% - 240px)', 'calc(100% - 240px)', 'calc(100% - 240px)'],
    transform: ['none', 'none', 'translateY(-50%)', 'translateY(-50%)', 'translateY(-50%)', 'translateY(-50%)'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    padding: ['0 40px 0 40px',
    // mobile
    '0 64px 0 64px',
    // mobilelg
    '0 173px 0 120px',
    // tablet
    '0 394px 0 155px',
    // tabletlg
    '0 534px 0 175px',
    // desktop
    '0 229px 0 229px' // widescreen
    ],
    zIndex: theme.zIndex.documentUp,
    overflow: 'hidden'
  },
  title: {
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    textTransform: 'none',
    letterSpacing: theme.letterSpacings.mediumCaps,
    color: theme.rawColors.neutralWhite,
    textAlign: 'left',
    lineHeight: '96%',
    fontSize: 'clamp(56px, calc(29.2px + 7.14vw), 132px)',
    paddingBottom: '7px'
  },
  /** Kompensuje odstęp, który normalnie zostawia blok podtytułu. */
  titleWithoutSubtitle: {
    marginBottom: ['24px', '20px', '20px', '32px', '32px', '40px']
  },
  subtitle: {
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.medium,
    color: theme.rawColors.neutralWhite,
    textAlign: 'left',
    textShadow: '0px 0px 100px #000',
    lineHeight: ['120%', '170%', '170%', '170%', '170%', '170%'],
    marginBottom: ['24px', '20px', '20px', '32px', '32px', '40px'],
    fontSize: ['16px',
    // mobile
    '16px',
    // mobilelg
    '16px',
    // tablet
    '16px',
    // tabletlg
    '18px',
    // desktop
    '24px' // widescreen
    ],
    '@media (min-width: 768px)': {
      whiteSpace: 'nowrap'
    }
  },
  ctaButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ['10px 24px 9px', '10px 24px 9px', '10px 24px 9px', '10px 24px 9px', '10px 24px 9px', '10px 24px 9px'],
    border: 'none',
    backgroundColor: theme.rawColors.neutralWhite,
    color: theme.rawColors.neutralBlack,
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    letterSpacing: '1%',
    lineHeight: '140%',
    cursor: 'pointer',
    fontSize: ['14px',
    // mobile
    '14px',
    // mobilelg
    '14px',
    // tablet
    '16px',
    // tabletlg
    '16px',
    // desktop
    '16px' // widescreen
    ],
    ...reusables.mainTransition('background-color, color', theme.transitions.animation.atomCurve, theme.transitions.time.fast),
    '&:hover': {
      backgroundColor: theme.rawColors.neutralBlack,
      color: theme.rawColors.neutralWhite
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.rawColors.blue500}`,
      outlineOffset: '2px'
    }
  },
  cartButtonContainer: {
    position: 'absolute',
    bottom: ['8px', '12px', '24px', '28px', '32px', '36px'],
    left: ['4px', '8px', '24px', '28px', '32px', '40px'],
    zIndex: theme.zIndex.documentUp + 1
  },
  mediaContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    },
    video: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }
};